/* =============================================================================
   Atypical — behaviour extracted from snippets/product-card.liquid
   -----------------------------------------------------------------------------
   This ran as an inline <script> emitted inside the first product card on every
   collection page. Same code, but now cached once as a real asset instead of
   re-sent with every page of results.

   Injects the "View on model" toggle into the collection toolbar and flips
   data-model-view on <html>; assets/atypical.css does the rest.
   ============================================================================= */

(function () {
  if (window.__atModelView) return;
  window.__atModelView = true;
  function injectButton() {
    var list = document.querySelector('.collection-toolbar__button-list');
    if (!list) return;

    // Only offer the toggle when this page actually has something to toggle to.
    // A model shot only exists for a product whose media carries alt text
    // containing "model" — most products have none, so on those collections the
    // control was appearing and then doing nothing when pressed.
    var existing = list.querySelector('[data-model-view-toggle]');
    if (!document.querySelector('.product-card__image--model')) {
      if (existing) existing.closest('.collection-toolbar__button-container').remove();
      return;
    }
    if (existing) return;
    var c = document.createElement('div');
    c.className = 'collection-toolbar__button-container';
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'collection-toolbar__button heading text-xxs w-full';
    b.setAttribute('data-model-view-toggle', '');
    b.setAttribute('aria-pressed', document.documentElement.getAttribute('data-model-view') === 'on' ? 'true' : 'false');
    b.innerHTML = '<span class="text-with-icon justify-center"><span data-model-toggle-label>' + (document.documentElement.getAttribute('data-model-view') === 'on' ? 'View product' : 'View on model') + '</span></span>';
    c.appendChild(b);
    list.appendChild(c);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-model-view-toggle]');
    if (!btn) return;
    var on = document.documentElement.getAttribute('data-model-view') !== 'on';
    document.documentElement.setAttribute('data-model-view', on ? 'on' : 'off');
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = btn.querySelector('[data-model-toggle-label]');
    if (label) label.textContent = on ? 'View product' : 'View on model';
  });
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', injectButton); } else { injectButton(); }
  document.addEventListener('shopify:section:load', injectButton);
  window.addEventListener('pageshow', injectButton);
})();
  
/* -----------------------------------------------------------------------------
   Drawer menu items to leave out.
   -----------------------------------------------------------------------------
   STOPGAP, and deliberately a small one. Navigation menus are store-level, not
   theme-level, so the real removal is Online Store -> Navigation -> Main menu.
   That edit applies to whatever theme is published — i.e. it would change the
   live storefront the moment it is saved, before this redesign ships. Doing it
   here keeps the change inside the theme until publish.

   Note what "Collections" holds: All COLLECTIONS, ATCoastal, ATMotion,
   ATKNITCODE, ATSOCIETY, ATStudio — the drawer's only route to the drops.

   Delete this block once the menu itself is edited.
   -------------------------------------------------------------------------- */
(function () {
  var REMOVE = ['Collections'];

  function prune() {
    var lists = document.querySelectorAll('.header-sidebar__scroller > .header-sidebar__linklist');
    lists.forEach(function (list) {
      list.querySelectorAll(':scope > li').forEach(function (li) {
        var control = li.querySelector('.header-sidebar__linklist-button, a');
        if (!control) return;
        if (REMOVE.indexOf(control.textContent.trim()) === -1) return;

        // take the item's sub-panel with it, so nothing is left orphaned
        var panelId = control.getAttribute('aria-controls');
        if (panelId) {
          var panel = document.getElementById(panelId);
          if (panel) panel.remove();
        }
        li.remove();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prune);
  } else {
    prune();
  }
  document.addEventListener('shopify:section:load', prune);
})();

/* -----------------------------------------------------------------------------
   Colour selector — fallback for products with no small collection to read.
   -----------------------------------------------------------------------------
   snippets/colour-swatches.liquid builds the row server-side by scanning the
   smallest collection the product belongs to. Some products belong only to
   Men's Exclusive (145 items) and Sale (106), both past the 50-item ceiling on
   collection.products, so there is nothing safe to scan. Those render an empty
   [data-colour-group] and are filled here.

   The group is found through the predictive-search endpoint rather than by
   guessing handles: the title convention gives the base name, search gives the
   products, and the base is re-checked exactly on the way in so that a fuzzy
   match ("The Static Pants" also returning "The Static Jacket") cannot put a
   different garment in the row.

   Colour is the last " - " segment of the title. Both dash characters in the
   catalogue are normalised first.
   -------------------------------------------------------------------------- */
(function () {
  var SEP = ' - ';

  function parts(title) {
    return String(title || '')
      .trim()
      .replace(/ [–—] /g, SEP)
      .split(SEP)
      .map(function (s) { return s.trim(); });
  }

  function baseOf(title) {
    var p = parts(title);
    return p.length > 1 ? p.slice(0, -1).join(SEP) : null;
  }

  function colourOf(title) {
    var p = parts(title);
    return p.length > 1 ? p[p.length - 1] : '';
  }

  function render(box, group) {
    var count = group.length;
    var list = group
      .map(function (p) {
        var current = p.handle === box.dataset.colourCurrent;
        var colour = colourOf(p.title);
        // suggest.json hands back the ORIGINAL file — 2158px square here — for
        // a 72px tile. Ask the CDN to resize instead of shipping four of those.
        var src = p.image ? p.image + (p.image.indexOf('?') === -1 ? '?' : '&') + 'width=200' : null;
        var img = src
          ? '<img class="colour-swatches__image" src="' + src + '" alt="' + colour + '" width="200" height="200" loading="lazy" draggable="false">'
          : '<span class="colour-swatches__image colour-swatches__image--empty" aria-hidden="true"></span>';
        return (
          '<li><a href="' + p.url + '" class="colour-swatches__item' + (current ? ' is-current' : '') + '"' +
          ' title="' + colour + '"' + (current ? ' aria-current="page"' : '') + ' data-instant>' +
          img + '<span class="sr-only">' + colour + '</span></a></li>'
        );
      })
      .join('');

    var currentColour = '';
    group.forEach(function (p) {
      if (p.handle === box.dataset.colourCurrent) currentColour = colourOf(p.title);
    });

    box.innerHTML =
      '<p class="colour-swatches__header">' +
      '<span class="colour-swatches__label">Colour<sup class="colour-swatches__count">' + count + '</sup></span>' +
      '<span class="colour-swatches__value">' + currentColour + '</span>' +
      '</p><ul class="colour-swatches__list unstyled-list" role="list">' + list + '</ul>';
    box.hidden = false;
  }

  function fill(box) {
    if (box.dataset.colourFilled) return;
    box.dataset.colourFilled = '1';

    var base = box.dataset.colourGroup;
    if (!base) return;

    var url =
      '/search/suggest.json?q=' + encodeURIComponent(base) +
      '&resources[type]=product&resources[limit]=10&resources[options][fields]=title';

    fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var found = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        var group = found.filter(function (p) {
          var b = baseOf(p.title);
          return b && b.toLowerCase() === base.toLowerCase();
        });
        // One of anything is not a choice, so one colour is not a row.
        if (group.length > 1) render(box, group);
      })
      .catch(function () { /* leave the row hidden rather than half-built */ });
  }

  function scan() {
    document.querySelectorAll('.colour-swatches--deferred[data-colour-group]').forEach(fill);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();

/* -----------------------------------------------------------------------------
   Size guide — dialog, tabs, and the size recommender.
   -----------------------------------------------------------------------------
   Native <dialog>, so Escape, focus trapping and inerting the rest of the page
   come from the platform rather than from Prestige's modal internals, which a
   theme update is free to rename. The only things added are closing on a
   backdrop click, which <dialog> does not do on its own, and the tab strip.

   THE RECOMMENDATION, AND WHAT IT IS NOT
   --------------------------------------
   It is a heuristic, and the copy in the dialog says so. Height and weight do
   not determine chest circumference; they narrow it. The bands below are the
   ordinary menswear ones for a 175cm frame, with weight adjusted 0.4kg per cm
   of height away from that — a taller person carries the same weight on a
   longer frame and takes the same size, so the adjustment moves the threshold,
   not the person.

   Two things then shift the result, in this order:
     1. the product's own custom.fit_recommendation metafield ("Size Up" /
        "Size Down"), which is the store's real knowledge of how the piece runs
     2. the shopper's stated preference (Snug / Relaxed)

   The result is clamped to the sizes this product actually has, and if that
   size is sold out the nearest available one is offered instead of sending
   someone to a disabled button.
   -------------------------------------------------------------------------- */
(function () {
  // Upper weight bound of each rung at 175cm. Index matches the ladder in
  // snippets/size-guide.liquid: xxs, xs, s, m, l, xl, xxl, xxxl.
  var BANDS = [46, 55, 63, 75, 88, 102, 118, Infinity];
  var BASE_HEIGHT = 175;
  var KG_PER_CM = 0.4;

  function parseSizes(el) {
    return (el.dataset.sizes || '')
      .split(',')
      .filter(Boolean)
      .map(function (entry) {
        var bits = entry.split('|');
        return { rung: parseInt(bits[0], 10), label: bits[1], available: bits[2] === 'y' };
      })
      .sort(function (a, b) { return a.rung - b.rung; });
  }

  function rungFor(height, weight) {
    var effective = weight - (height - BASE_HEIGHT) * KG_PER_CM;
    for (var i = 0; i < BANDS.length; i++) {
      if (effective <= BANDS[i]) return i;
    }
    return BANDS.length - 1;
  }

  function nearest(sizes, rung) {
    var best = null;
    var bestGap = Infinity;
    sizes.forEach(function (s) {
      var gap = Math.abs(s.rung - rung);
      if (gap < bestGap) { bestGap = gap; best = s; }
    });
    return best;
  }

  function nearestAvailable(sizes, rung) {
    return nearest(sizes.filter(function (s) { return s.available; }), rung);
  }

  function recommend(box) {
    var out = box.querySelector('[data-size-guide-result]');
    var height = parseFloat(box.querySelector('[data-size-guide-height]').value);
    var weight = parseFloat(box.querySelector('[data-size-guide-weight]').value);

    function say(text, kind) {
      out.textContent = text;
      out.hidden = false;
      out.className = 'size-guide__result' + (kind ? ' size-guide__result--' + kind : '');
    }

    if (!height || !weight) return say('Enter your height and weight to see a suggestion.', 'quiet');
    if (height < 120 || height > 220) return say('Height should be between 120 and 220 cm.', 'quiet');
    if (weight < 35 || weight > 200) return say('Weight should be between 35 and 200 kg.', 'quiet');

    var sizes = parseSizes(box);
    if (!sizes.length) return say('No sizes to suggest for this piece.', 'quiet');

    var selected = box.querySelector('[data-size-guide-fit].is-selected');
    var preference = selected ? parseInt(selected.getAttribute('data-size-guide-fit'), 10) : 0;
    var fitShift = parseInt(box.dataset.fitShift, 10) || 0;

    var target = rungFor(height, weight) + fitShift + preference;
    var pick = nearest(sizes, target);
    if (!pick) return say('No sizes to suggest for this piece.', 'quiet');

    var message = 'We’d suggest ' + pick.label + '.';

    var note = (box.dataset.fitNote || '').toLowerCase();
    if (note === 'size up') message += ' This piece runs small, so that is a size above your usual.';
    else if (note === 'size down') message += ' This piece runs large, so that is a size below your usual.';

    if (!pick.available) {
      var alt = nearestAvailable(sizes, target);
      message += alt
        ? ' It is sold out — ' + alt.label + ' is the closest in stock.'
        : ' It is sold out, and so is every other size.';
    }

    say(message, 'found');
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-size-guide-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-size-guide-open'));
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }

    if (e.target.closest('[data-size-guide-close]')) {
      var open = e.target.closest('dialog');
      if (open) open.close();
      return;
    }

    // A click landing on the dialog element itself is a click on the backdrop:
    // the panel inside it covers everything else.
    if (e.target.classList && e.target.classList.contains('size-guide__dialog')) {
      e.target.close();
      return;
    }

    var tab = e.target.closest('.size-guide__tab');
    if (tab) {
      var strip = tab.parentElement;
      strip.querySelectorAll('.size-guide__tab').forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-selected', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      return;
    }

    var choice = e.target.closest('[data-size-guide-fit]');
    if (choice) {
      choice.parentElement.querySelectorAll('[data-size-guide-fit]').forEach(function (c) {
        var on = c === choice;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      return;
    }

    var submit = e.target.closest('[data-size-guide-submit]');
    if (submit) recommend(submit.closest('[data-size-guide-finder]'));
  });

  // Enter in either number field should submit, not do nothing.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var field = e.target.closest('[data-size-guide-height], [data-size-guide-weight]');
    if (!field) return;
    e.preventDefault();
    recommend(field.closest('[data-size-guide-finder]'));
  });
})();

/* -----------------------------------------------------------------------------
   Complete the look — let Shopify's complementary recommendations lead.
   -----------------------------------------------------------------------------
   Liquid cannot ask for intent=complementary during a page render; only the
   /recommendations/products route can, and it answers by rendering this
   section. So the page is served with the theme's own colour-linked look
   already in place and Shopify is asked afterwards.

   Shopify's picks are a merchant saying "this goes with that", so they lead
   the row. They do not empty it: Shopify drops sold-out products from
   complementary results, which on this store means a curated list of three
   comes back as two because the piece between stock runs is removed. Replacing
   four cards with two would punish the merchant for curating, so the picks are
   merged to the front and the theme's own suggestions fill the rest.

   Deliberately not intent=related: that is the same engine behind the Related
   products section lower down, and on Origin Tee it returns Origin Tee in
   Green and Blanco. More of the same garment is the opposite of a look.
   -------------------------------------------------------------------------- */
(function () {
  function merge(box) {
    var url = box.getAttribute('data-ctl-url');
    if (!url || box.dataset.ctlAsked) return;
    box.dataset.ctlAsked = '1';

    var grid = box.querySelector('.complete-the-look__grid');
    if (!grid) return;
    var slots = grid.children.length;

    fetch(url)
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var picks = doc.querySelectorAll('.complete-the-look__grid > *');
        if (!picks.length) return;

        var handles = [];
        picks.forEach(function (li) {
          var card = li.matches('product-card') ? li : li.querySelector('product-card');
          if (card) handles.push(card.getAttribute('handle'));
        });

        // Drop the theme's version of anything Shopify also picked, so a
        // product cannot appear twice in the row.
        Array.prototype.slice.call(grid.children).forEach(function (child) {
          var card = child.matches('product-card') ? child : child.querySelector('product-card');
          if (card && handles.indexOf(card.getAttribute('handle')) !== -1) child.remove();
        });

        for (var i = picks.length - 1; i >= 0; i--) {
          grid.insertBefore(picks[i], grid.firstChild);
        }

        while (grid.children.length > slots) {
          grid.removeChild(grid.lastChild);
        }

        box.setAttribute('data-ctl-source', 'shopify');
      })
      .catch(function () { /* keep the served look */ });
  }

  function scan() {
    document.querySelectorAll('[data-ctl-url]').forEach(merge);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();

/* -----------------------------------------------------------------------------
   Add to cart always opens a cart.
   -----------------------------------------------------------------------------
   Reported on a phone: the item goes in, and nothing on screen says so.

   Why the theme cannot be trusted to handle this here. Upsell by AMP replaces
   the cart at runtime: the theme's own <cart-drawer> is still in the DOM but
   measures 0x0, the PDP's add-to-cart form is NOT inside a <product-form>
   element any more, and the theme's "cart:change" event never fires on an add
   because the app intercepts the submit before Prestige sees it. So every
   hook Prestige would normally use is gone, and cart_type: "drawer" in theme
   settings is describing a drawer that no longer exists.

   In an emulated phone the app does open its own drawer on both the PDP and
   the quick-add, on the live theme and this one — so this is a net under a
   failure that could not be reproduced here, most likely the app's script not
   being ready yet on a slow connection, which is exactly a phone-on-mobile-data
   problem.

   It is therefore written to do NOTHING when the app works:

     1. an add is noticed, and the cart item count is read before it
     2. after a beat, if any cart UI is already open, this stops
     3. otherwise the count is re-read, and only if the cart actually GREW
        does anything happen — so a sold-out add or a failed request never
        pops a cart open
     4. then, in order: the app's own OPEN_CART, the theme's drawer if it has
        real height, and failing both, the cart page, which always works

   The count check is what keeps this honest. Without it, every add that
   silently failed would still open a cart and claim success.
   -------------------------------------------------------------------------- */
(function () {
  var SETTLE = 1400;
  var armedAt = 0;

  function count() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return j ? j.item_count : null; })
      .catch(function () { return null; });
  }

  function cartIsOpen() {
    if (document.querySelector('.amp-cart--open')) return true;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.hasAttribute('open') && drawer.getBoundingClientRect().height > 0) return true;
    return false;
  }

  function open() {
    if (window.AMP_API && typeof window.AMP_API.OPEN_CART === 'function') {
      try { window.AMP_API.OPEN_CART(); } catch (e) { /* fall through */ }
    }

    var drawer = document.querySelector('cart-drawer');
    if (!cartIsOpen() && drawer && typeof drawer.show === 'function') {
      try { drawer.show(); } catch (e) { /* fall through */ }
    }

    // Give whichever one was asked a moment to animate in before giving up on
    // it — a drawer mid-transition has no height yet.
    setTimeout(function () {
      if (!cartIsOpen()) window.location.assign('/cart');
    }, 500);
  }

  function arm() {
    var now = Date.now();
    if (now - armedAt < SETTLE) return;
    armedAt = now;

    var before = null;
    count().then(function (c) { before = c; });

    setTimeout(function () {
      if (cartIsOpen()) return;
      count().then(function (after) {
        if (before === null || after === null) return;
        if (after > before) open();
      });
    }, SETTLE);
  }

  function isAddControl(el) {
    var form = el.closest('form');
    if (form && String(form.action).indexOf('/cart/add') !== -1) return true;
    // The quick-add button on a card posts through its own form; the PDP's
    // button may have been re-parented by the app.
    return !!el.closest('product-form, .product-card__quick-add-button');
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && String(form.action).indexOf('/cart/add') !== -1) arm();
  }, true);

  document.addEventListener('click', function (e) {
    var control = e.target.closest('button, input[type="submit"], [role="button"]');
    if (!control) return;
    if (control.type === 'button' && !control.closest('.product-card__quick-add-button')) {
      // Not a submit and not the quick-add plus: this is a size swatch, a
      // quantity step, a close button. Leave it alone.
      if (control.getAttribute('name') !== 'add') return;
    }
    if (isAddControl(control)) arm();
  }, true);
})();
